/**
 * @desc 选择框组件默认配置相关信息
 * @link http://design.umu.work/#/umu_design/src/components/umu-select
*/
const defaultSelectConfig = {

}

export const selectConfig = {
    defaultSelectConfig,
}
